import { BaseProps as InputProps } from 'components/base/Form/Input/types'

export enum Theme {
  auto = 'auto',
  home = 'home',
  concierge = 'concierge',
}

export interface Props extends InputProps {
  isSpaced?: boolean,
  labelCentered?: boolean,
  isCentered?: boolean,
  loading?: boolean,
  tooltip?: string | React.ReactElement,
  children?: React.ReactElement | React.ReactElement[],
}

export interface StyleProps {
  isSpaced: boolean,
  isCentered: boolean,
}
